import {Observable} from 'rxjs/Observable';
import {endLeadGenPickAction, Types} from "./actions";
import * as ResourceApi from 'api/resources';
import {createdResourceAction} from "../../resources/actions";
import {extractResourceIdsWithPath} from "../../utils/DBUtils";

const submitLeadGenPickEpic = (action$, store) => action$.ofType(Types.SUBMIT_LEAD_GEN_PICK)
    .mergeMap((action) => {
        const picker = store.getState().leadGenFieldPicker;
        return ResourceApi.create(ResourceApi.Types.LeadGenField, {
            names: action.fields
        }, [picker.pickingForLeadGen.resourceId])
            .mergeMap(({response: {object}}) => {

              return Observable.of(
                endLeadGenPickAction(),
                createdResourceAction(
                  object,
                  picker.brk,
                  extractResourceIdsWithPath(
                    store.getState().resources.resources, picker.brk,
                    picker.brk,
                    picker.resourcePath
                  ),
                  picker.resourcePath,
                  picker.fieldPath)
              )
            })
            .catch(err => Observable.of({type: "ERROR", error: err}))
    });

export default [
    submitLeadGenPickEpic
]


// WEBPACK FOOTER //
// ./public/pages/LeadGenFieldPicker/epics.js